/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AnqServiceListDto } from '../model/anqServiceListDto';
import { PlatformServiceSubscriptionProcess } from '../model/platformServiceSubscriptionProcess';
import { RateMappingDto } from '../model/rateMappingDto';
import { ServiceClientsDto } from '../model/serviceClientsDto';
import { ServiceSubscription } from '../model/serviceSubscription';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ServiceSubscriptionService {

    protected basePath = 'http://10.1.1.123:30116';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public serviceSubscriptionCreate(model: AnqServiceListDto, observe?: 'body', reportProgress?: boolean): Observable<ServiceSubscription>;
    public serviceSubscriptionCreate(model: AnqServiceListDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServiceSubscription>>;
    public serviceSubscriptionCreate(model: AnqServiceListDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServiceSubscription>>;
    public serviceSubscriptionCreate(model: AnqServiceListDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling serviceSubscriptionCreate.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ServiceSubscription>(`${this.basePath}/api/ServiceSubscription/createNewSubscription`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public serviceSubscriptionCreatePlatformServiceSubscription(model: PlatformServiceSubscriptionProcess, observe?: 'body', reportProgress?: boolean): Observable<ServiceSubscription>;
    public serviceSubscriptionCreatePlatformServiceSubscription(model: PlatformServiceSubscriptionProcess, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServiceSubscription>>;
    public serviceSubscriptionCreatePlatformServiceSubscription(model: PlatformServiceSubscriptionProcess, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServiceSubscription>>;
    public serviceSubscriptionCreatePlatformServiceSubscription(model: PlatformServiceSubscriptionProcess, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling serviceSubscriptionCreatePlatformServiceSubscription.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ServiceSubscription>(`${this.basePath}/api/ServiceSubscription/CreatePlatformServiceSubscription`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public serviceSubscriptionDelete(id?: string, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public serviceSubscriptionDelete(id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public serviceSubscriptionDelete(id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public serviceSubscriptionDelete(id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<boolean>(`${this.basePath}/api/ServiceSubscription/deleteSubscription`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public serviceSubscriptionGetAll(observe?: 'body', reportProgress?: boolean): Observable<Array<ServiceSubscription>>;
    public serviceSubscriptionGetAll(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ServiceSubscription>>>;
    public serviceSubscriptionGetAll(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ServiceSubscription>>>;
    public serviceSubscriptionGetAll(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<ServiceSubscription>>(`${this.basePath}/api/ServiceSubscription/getAllSubscriptions`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public serviceSubscriptionGetServiceSubscriptionByCreatorId(id?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ServiceSubscription>>;
    public serviceSubscriptionGetServiceSubscriptionByCreatorId(id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ServiceSubscription>>>;
    public serviceSubscriptionGetServiceSubscriptionByCreatorId(id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ServiceSubscription>>>;
    public serviceSubscriptionGetServiceSubscriptionByCreatorId(id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<ServiceSubscription>>(`${this.basePath}/api/ServiceSubscription/getByCreatorId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public serviceSubscriptionGetServiceSubscriptionById(id?: string, observe?: 'body', reportProgress?: boolean): Observable<ServiceSubscription>;
    public serviceSubscriptionGetServiceSubscriptionById(id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServiceSubscription>>;
    public serviceSubscriptionGetServiceSubscriptionById(id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServiceSubscription>>;
    public serviceSubscriptionGetServiceSubscriptionById(id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ServiceSubscription>(`${this.basePath}/api/ServiceSubscription/getById`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param name 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public serviceSubscriptionGetServiceSubscriptionByName(name?: string, observe?: 'body', reportProgress?: boolean): Observable<ServiceSubscription>;
    public serviceSubscriptionGetServiceSubscriptionByName(name?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServiceSubscription>>;
    public serviceSubscriptionGetServiceSubscriptionByName(name?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServiceSubscription>>;
    public serviceSubscriptionGetServiceSubscriptionByName(name?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (name !== undefined && name !== null) {
            queryParameters = queryParameters.set('name', <any>name);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ServiceSubscription>(`${this.basePath}/api/ServiceSubscription/getByName`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public serviceSubscriptionMapAllServices(model: ServiceClientsDto, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public serviceSubscriptionMapAllServices(model: ServiceClientsDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public serviceSubscriptionMapAllServices(model: ServiceClientsDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public serviceSubscriptionMapAllServices(model: ServiceClientsDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling serviceSubscriptionMapAllServices.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<string>(`${this.basePath}/api/ServiceSubscription/MapAllServices`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public serviceSubscriptionResourceMapping(model: RateMappingDto, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public serviceSubscriptionResourceMapping(model: RateMappingDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public serviceSubscriptionResourceMapping(model: RateMappingDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public serviceSubscriptionResourceMapping(model: RateMappingDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling serviceSubscriptionResourceMapping.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<string>(`${this.basePath}/api/ServiceSubscription/ResourceMapping`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param creatorId 
     * @param serviceName 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public serviceSubscriptionTestMap(creatorId?: string, serviceName?: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public serviceSubscriptionTestMap(creatorId?: string, serviceName?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public serviceSubscriptionTestMap(creatorId?: string, serviceName?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public serviceSubscriptionTestMap(creatorId?: string, serviceName?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (creatorId !== undefined && creatorId !== null) {
            queryParameters = queryParameters.set('creatorId', <any>creatorId);
        }
        if (serviceName !== undefined && serviceName !== null) {
            queryParameters = queryParameters.set('serviceName', <any>serviceName);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.post<string>(`${this.basePath}/api/ServiceSubscription/TestMap`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param creatorId 
     * @param subscriptionStatus 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public serviceSubscriptionUpdate(id?: string, creatorId?: string, subscriptionStatus?: boolean, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public serviceSubscriptionUpdate(id?: string, creatorId?: string, subscriptionStatus?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public serviceSubscriptionUpdate(id?: string, creatorId?: string, subscriptionStatus?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public serviceSubscriptionUpdate(id?: string, creatorId?: string, subscriptionStatus?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }
        if (creatorId !== undefined && creatorId !== null) {
            queryParameters = queryParameters.set('creatorId', <any>creatorId);
        }
        if (subscriptionStatus !== undefined && subscriptionStatus !== null) {
            queryParameters = queryParameters.set('subscriptionStatus', <any>subscriptionStatus);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<boolean>(`${this.basePath}/api/ServiceSubscription/updateSubscription`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
